import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Row, Form, Container, Modal } from "react-bootstrap";
import Seoanalyzeres from "./Seoanalyzeres";

const Seoauditt = () => {
  const [URL, setURL] = useState("");
  const [showResults, setShowResults] = useState(false);

  const handleChange = (event) => {
    setURL(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowResults(true);
  };

  const handleClose = () => {
    setShowResults(false);
    setURL("");
  };

  return (
    <div className="mt-4">
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      <Container
        fluid
        className="px-4 py-5"
        style={{
          background:
            "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
        }}
      >
        <Row className="d-flex justify-content-center">
          <Col md={10}>
            <div className="mb-3">
              <h1
                style={{
                  fontSize: "4.5rem",
                  fontWeight: "500",
                  color: "#090040",
                }}
              >
                SEO Inspector Tool
              </h1>
              <p style={{ fontSize: "1.2rem", color: "#090040" }}>
                Try the free version of SEOBIX SEO Inspectoror. Get a glimpse <br />
                into the power of our premium tool.
              </p>
            </div>

            <Form onSubmit={handleSubmit} className="mb-4">
              <Row className="g-2">
                <Col md={7}>
                  <Form.Group controlId="formURLInput">
                    <Form.Label className="visually-hidden">
                      Website URL
                    </Form.Label>
                    <Form.Control
                      value={URL}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter domain (e.g. seobix.com)"
                      className="shadow-sm px-4"
                      style={{
                        color: "#090040",
                        borderRadius: 0,
                        fontSize: "1.2rem",
                        height: "48px",
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Button
                    type="submit"
                    className="w-100"
                    style={{
                      background: "#F80",
                      color: "#fff",
                      border: "none",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      borderRadius: 0,
                      height: "48px",
                    }}
                  >
                    Inspect
                  </Button>
                </Col>
              </Row>
            </Form>

            <Row>
              <Col md={6}>
                <h3
                  className="fw-semibold mb-3"
                  style={{ fontSize: "2.5rem", color: "#090040" }}
                >
                  Boost Rankings with a Full SEO Site Audit
                </h3>
                <p style={{ fontSize: "1.2rem", color: "#090040" }}>
                  Conduct a comprehensive site audit to{" "}
                  <span style={{ color: "#B12C00" }}>identify issues</span>, fix
                  errors, and uncover opportunities that improve your search
                  engine rankings and overall website performance.
                </p>

                <p
                  className="mb-4"
                  style={{ fontSize: "1.5rem", color: "#090040" }}
                >
                  Start Your SEO Journey with SeoBix!
                </p>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <a
                    href="/register"
                    className="start-now-btn"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Sign Up with 3 month free trial
                  </a>
                  <span
                    style={{
                      color: "#F80",
                      fontWeight: "700",
                      whiteSpace: "nowrap",
                    }}
                  >
                    OR
                  </span>
                  <a
                    href="/register"
                    className="start-now-btn"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Explore More Tools
                  </a>
                </div>
              </Col>

              <Col md={6}>
                <Row>
                  <Col xs={6} className="text-center mb-4">
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: 600,
                        color: "#090040",
                      }}
                    >
                      1M+
                    </div>
                    <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                      Pages in index
                    </div>
                  </Col>
                  <Col xs={6} className="text-center mb-4">
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: 600,
                        color: "#090040",
                      }}
                    >
                      60K+
                    </div>
                    <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                      Internal backlinks
                    </div>
                  </Col>
                  <Col xs={6} className="text-center">
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: 600,
                        color: "#090040",
                      }}
                    >
                      100+
                    </div>
                    <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                      Domains
                    </div>
                  </Col>
                  <Col xs={6} className="text-center">
                    <div
                      style={{
                        fontSize: "4rem",
                        fontWeight: 600,
                        color: "#090040",
                      }}
                    >
                      200K+
                    </div>
                    <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                      External backlinks
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* MODAL for SeoAnalyzer */}
      <Modal
        show={showResults}
        onHide={handleClose}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>SEO Inspector Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Seoanalyzeres url={URL} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Seoauditt;
